// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__UbhOT","image":"Image_image__4hz0C","default":"Image_default__U7IAa","list":"Image_list__0jBB6"};